var map = {
	"./chainge.jpg": 75646,
	"./coin98.png": 24273,
	"./coin98.svg": 53063,
	"./coinbase.png": 77789,
	"./coinbase.svg": 17867,
	"./gate.png": 75656,
	"./glider2@2x.png": 54038,
	"./kucoin.png": 50966,
	"./metamask.png": 25278,
	"./metamask.svg": 9800,
	"./pancake.png": 55624,
	"./pangolin.png": 69961,
	"./safepal.png": 32055,
	"./safepal.svg": 44119,
	"./trustwallet.png": 54784,
	"./trustwallet.svg": 58644,
	"./uniswap.png": 24430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48989;